export const CREATE_CONSENT = 'CREATE_CONSENT';
export const RENEW_TOKEN = 'RENEW_TOKEN';
export const RENEW_CONSENT = 'RENEW_CONSENT';